import Video from './Video';

document.addEventListener('DOMContentLoaded', () => {
  const $videos = document.querySelectorAll('.c-video');
  if (!$videos.length) {
    return;
  }

  $videos.forEach(($video) => {
    const video = new Video($video);
    video.mount();
  });
});
